/**
 * @module app.core
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { TransitionalManager } from 'app/shared/lib/transitional/manager';
import { AccountContext } from 'app/core/lib/account-context';


@autoinject()
export class EssTransitionalLinkCustomElement {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView })
    public display: string | null = null;
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView })
    public pageId: string | null = null;
    @bindable.array({ defaultBindingMode: bindingMode.toView })
    public transitionalIds: string[] = [];
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView })
    public tooltip: string | null = null;
    @bindable.boolean()
    public noUnderline: boolean = false;

    private showLink: boolean = false;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly transitional: TransitionalManager,
        private readonly accountContext: AccountContext) { }



    ////****************** Events ***************************************************////
    protected bind(bindingContext: Object, overrideContext: Object): void {
        this.loadPermissions();
    }


    ////****************** Functions ************************************************////
    private async loadPermissions(): Promise<void> {
        await this.accountContext.load();
        if(this.pageId) { this.showLink = this.accountContext.hasRouteAccess(this.pageId); }
    }

    protected openLink(): void {
        if(this.pageId) {
            this.transitional.openTransitional(null, this.pageId, this.transitionalIds!);
        }
    }


    ////****************** Service Calls ********************************************////

}

